var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 0.952258C24.557 0.00925027 23.0281 0.00925052 22.0851 0.952259L13.5477 9.48961L5.01038 0.952286C4.06737 0.00927817 2.53845 0.00927851 1.59544 0.952286C0.652434 1.8953 0.652435 3.42421 1.59544 4.36722L10.1328 12.9045L1.59545 21.4419C0.652436 22.3849 0.652437 23.9138 1.59544 24.8568C2.53845 25.7998 4.06737 25.7998 5.01038 24.8568L13.5477 16.3195L22.0851 24.8568C23.0281 25.7998 24.557 25.7998 25.5 24.8568C26.443 23.9138 26.443 22.3849 25.5 21.4419L16.9626 12.9045L25.5 4.36719C26.443 3.42419 26.443 1.89527 25.5 0.952258Z",
    fill: "#FF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.2e4bf288690e53ca7dfb4078f2200398.svg";
export { ForwardRef as ReactComponent };